import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AdminProvider } from './context/AdminContext';
import { ToastProvider } from './context/ToastContext';
import AppErrorBoundary from './components/AppErrorBoundary/AppErrorBoundary';
import Layout from './components/Layout/Layout';
import ExpensesPage from './pages/ExpensesPage';
import CategoryTreePage from './pages/CategoryTreePage';
import ExpenseEditorPage from './pages/ExpenseEditorPage';
import UploadPage from './pages/UploadPage';
import SignInPage from './pages/SignInPage';
import LogoutPage from './pages/LogoutPage';
import AdminPage from './pages/AdminPage';
import SettingsPage from './pages/SettingsPage';
import './App.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="appLoading" role="status" aria-live="polite">
        <div className="appLoadingSpinner" />
        <span>טוען...</span>
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/signin" replace />;
};

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <Router>
          <ToastProvider>
            <AppErrorBoundary>
            <Routes>
              <Route path="/signin" element={<SignInPage />} />
              <Route path="/login" element={<SignInPage />} />
              <Route path="/logout" element={<LogoutPage />} />
              <Route path="/auth/callback" element={<SignInPage />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<ExpensesPage />} />
                        <Route path="/tree" element={<CategoryTreePage />} />
                        <Route path="/editor" element={<ExpenseEditorPage />} />
                        <Route path="/upload" element={<UploadPage />} />
                        <Route path="/settings" element={<SettingsPage />} />
                        <Route path="/import" element={<Navigate to="/settings" replace />} />
                        <Route
                          path="/admin"
                          element={
                            <AdminProvider>
                              <AdminPage />
                            </AdminProvider>
                          }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
            </AppErrorBoundary>
          </ToastProvider>
        </Router>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
